import { LocalStorageService } from '../services/local-storage.service';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../constants-and-enums/pagination';

export function resolvePageSize(options: readonly number[] = DEFAULT_PAGE_SIZE_OPTIONS, fallback: number = DEFAULT_PAGE_SIZE): number {
    const preferredPageSize = LocalStorageService.getPreferredPageSize();

    return preferredPageSize !== undefined && options.includes(preferredPageSize) ? preferredPageSize : fallback;
}

// Paginators with their own option list must not overwrite the app-wide preference.
export function rememberPageSize(pageSize: number): void {
    if (DEFAULT_PAGE_SIZE_OPTIONS.includes(pageSize)) {
        LocalStorageService.setPreferredPageSize(pageSize);
    }
}
